import { Box } from "@chakra-ui/react";
import CommonContainer from "../components/shared/CommonContainer";
import JobPostLayout from "../components/jobpostpage/JobpostLayout";

export default function JobPostPage() {
  return (
    <>
      <CommonContainer>
        <Box py={10}>
          <JobPostLayout />
        </Box>
      </CommonContainer>
    </>
  );
}
